import React from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import CardActions from '@material-ui/core/CardActions';
import AppBar from '@material-ui/core/AppBar';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import { TwitterShareButton, TwitterIcon } from 'react-share';
import Modal from 'react-modal'

interface Deck {
    id: number;
    name: string;
    reverse: boolean;
    point: number;
};


interface Answer {
    id: number;
    name: string;
};


interface AnswerTotalState {
    totalCount: number;
};



// 一覧
const datalists: Deck[] = [
    { id: 1, name: "自分は周りの人たちの中になじんでいると感じますか", reverse: true, point: 0 },
    { id: 2, name: "自分には人との付き合いがないと感じることがありますか", reverse: false, point: 0 },
    { id: 3, name: "自分には頼れる人が誰もいないと感じることがありますか", reverse: false, point: 0 },
    { id: 4, name: "自分はひとりぼっちだと感じることがありますか", reverse: false, point: 0 },
    { id: 5, name: "自分は友人や仲間のグループの一員だと感じることがありますか", reverse: true, point: 0 },
    { id: 6, name: "自分は周りの人たちと共通点が多いと感じることがありますか", reverse: true, point: 0 },
    { id: 7, name: "自分は誰とも親しくしていないと感じることはありますか", reverse: false, point: 0 },
    { id: 8, name: "自分の関心や考えは周りの人たちにはわからないと感じることがありますか", reverse: false, point: 0 },
    { id: 9, name: "自分を社交的で親しみやすいと感じますか", reverse: true, point: 0 },
    { id: 10, name: "自分には親しい人たちがいると感じますか", reverse: true, point: 0 },
    { id: 11, name: "自分は取り残されていると感じることがありますか", reverse: false, point: 0 },
    { id: 12, name: "他人との関わりは意味がないと感じることがありますか", reverse: false, point: 0 },
    { id: 13, name: "自分のことを本当によく知っている人は誰もいないと感じることはありますか", reverse: false, point: 0 },
    { id: 14, name: "自分は他の人たちから孤立していると感じることはありますか", reverse: false, point: 0 },
    { id: 15, name: "希望すれば自分と気の合う仲間は見つかると感じますか", reverse: true, point: 0 },
    { id: 16, name: "自分を本当に理解している人がいると感じますか", reverse: true, point: 0 },
    { id: 17, name: "自分は内気であると感じますか", reverse: false, point: 0 },
    { id: 18, name: "周りの人たちと一体感がもてないと感じることがありますか", reverse: false, point: 0 },
    { id: 19, name: "話し相手がいると感じますか", reverse: true, point: 0 },
    { id: 20, name: "頼れる人がいると感じますか", reverse: true, point: 0 }
];



// 設問の答え
const ansList: Answer[] = [
    { id: 1, name: "決してない" },
    { id: 2, name: "ほとんどない" },
    { id: 3, name: "ときどきある" },
    { id: 4, name: "常にある" }

];

const useStyles = makeStyles((theme: Theme) => createStyles({
    // const useStyles = makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
        backgroundColor: 'transparent',
    },
    // Appbarの部分
    header: {
        backgroundColor: '#795548',
        position: 'fixed',
        top: 'auto',
        bottom: 0,
        fontSize: 18,
    },
    cardpage: {
        // position: 'absolute',
        zIndex: 1,
        // top: 10,
        // left: 0,
        // right: 0,
        // margin: 0,
        marginBottom: theme.spacing(2),
    },
    offset: theme.mixins.toolbar,
    labelitem: {

        // backgroundColor: 'skyblue',
        // 列幅の最低サイズ
        // minWidth:200,
        // margin: 0,
    },
    itemAnswers: {
        // minWidth: 50,
        // width: '%',
        justifyContent: 'center',
    },
    itemNo: {
        // width: 5,
        // fontSize: 16,
    },

    icon: {
        color: 'inherit',
    },
    avatar: {
        background: 'black',
    },
    closeBtn: {
        background: 'black',
        color: 'white',
        borderRadius: 20,
    }


}),
);

function finishFlg(): boolean {
    console.log("finishFlg-start!");
    let endflg: boolean;
    let cnt = 0;
    endflg = false;
    // datalists.map((row) => (total += row.point));
    datalists.forEach(syncDeck => {

        if (syncDeck.point > 0) {
            cnt++;
        }

    });

    if (cnt === datalists.length) {
        console.log("完了");
        endflg = true;
    } else {
        console.log("未完了");
        console.log(cnt);
    }
    return endflg;
}

function summaryPoint(): number {
    console.log("summaryPoint-start!");
    let total: number;
    total = 0;
    // datalists.map((row) => (total += row.point));
    datalists.forEach(syncDeck => {
        total += syncDeck.point


    });
    return total;
}

// Inspired by blueprintjs
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.labelitem}
            // disableRipple
            // color="default"
            // icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

// // CheckResult is 結果の表示
// function CheckResult(point: any) {

//     return (


//     );
// }

// 一覧表示
function CustomizedTables(state: AnswerTotalState, props: any) {


    console.log("CustomizedTables-start.");

    const classes = useStyles();

    const [point, setPoint] = React.useState<number>(0);
    const [flg, setFlg] = React.useState<boolean>(false);
    const [value, setValue] = React.useState('決してない');

    console.log(props.totalCount);
    // ラジオボタンの内容が変更されたとき
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        // console.log(event.target.value);
        setValue(event.target.value);
        let val = event.target.value;
        let arr = val.split(".").map(Number);
        let idx = arr[0] - 1;
        console.log(value);

        // 反転あり？
        if (datalists[idx].reverse) {
            // 反転があれば反転後がポイントになる。1なら4pt、4なら1pt
            console.log(arr[1]);
            datalists[idx].point = 5 - arr[1];
        } else {
            datalists[idx].point = arr[1];
        }

        // 合計ｐｔを算出する
        let pt = summaryPoint();
        console.log("ポイント↓");
        console.log(pt);
        setPoint(pt);

        let f = finishFlg();
        setFlg(f);
        console.log(f);
    };

    const shareUrl = 'https://ts-cheker-three.vercel.app';
    const title = '孤独感尺度計測ツール【' + point + '】';
    const twthashtags = ['孤独感尺度', 'ぼっち度', '孤独感診断'];




    return (
        <React.Fragment>
            <CssBaseline />


            <Modal
                isOpen={flg}
                contentLabel="結果解説"
                onRequestClose={() => setFlg(false)}

                style={{
                    overlay: {
                        marginLeft:'auto',
                        marginTop:'top',
                        height: '400px',
                        // width: '500px',
                        zIndex: 'auto',
                        backgroundColor: 'rgba(155, 155, 255, 0.75)',
                        borderRadius: '20px',
                        alignItems: 'center'

                    },
                    content: {
                        marginLeft:'auto',
                        marginTop:'top',
                        textAlign:'center',
                        border: '1px solid #000',
                        background: '#efe',
                        // alignItems: 'center',
                        
                        // top: '40px',
                        // left: '40px',
                        // right: '40px',
                        // bottom: '40px',
                
                        // overflow: 'auto',
                        // WebkitOverflowScrolling: 'touch',
                        borderRadius: '50px',
                        // outline: 'none',
                        padding: '20px'
                    }
                }}
            >
                <div >
                    <h1>🎉結果発表🎉</h1>
                    <h3> あなたの孤独感は「{point}」でした💡</h3>
                    <h4>🔍点数基準🔍</h4>
                    <p>  ２８点未満：孤独度低い</p>
                    <p>  ４４点以上：孤独度高い</p>
                </div >
                {/* <CheckResult pt={point} /> */}
                <button
                    className={classes.closeBtn}
                    onClick={() => setFlg(false)}>閉じる
                </button>
            </Modal>
            <Paper elevation={3} className={classes.root}>

                {/* 質問一覧 */}
                {datalists.map((row) => (
                    <Card key={row.name} className={classes.cardpage}>
                        {/* これが表示されない（Noだからどっちでもいいけど） */}
                        <CardHeader
                            avatar={
                                <Avatar aria-label="no" className={classes.avatar}>
                                    {row.id}
                                </Avatar>
                            }
                            title={row.name}
                        />
                        <CardActions className={classes.itemAnswers}>
                            {/*  */}
                            {/* 以下ボタン表示,決してない ほとんどない 1-4 ときどきある 常にある */}
                            <FormControl component="fieldset">
                                <RadioGroup
                                    aria-label="Q"
                                    name={"Q" + row.id}
                                    // value="質問"

                                    onChange={handleChange}
                                >
                                    {/* 回答数分繰り返し */}
                                    {ansList.map((ans) => (
                                        <FormControlLabel
                                            value={row.id + "." + ans.id}
                                            key={row.id + "." + ans.id}
                                            control={<StyledRadio />}
                                            label={ans.name}
                                            className={classes.labelitem}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </CardActions>
                    </Card>
                ))}

            </Paper>
            孤独感尺度より
            http://www-user.yokohama-cu.ac.jp/~ycu_chn/wp/wp-content/uploads/2018/06/UCLA-LS3-j.pdf
            <div className={classes.offset}></div>



            <AppBar
                color="primary"
                className={classes.header}>
                孤独感尺度計測ツール【{point}】

                <TwitterShareButton
                    url={shareUrl}
                    title={title}
                    className="Demo__some-network__share-button"
                    hashtags={twthashtags}
                >
                    <TwitterIcon size={32} round />
                </TwitterShareButton>


            </AppBar>


        </React.Fragment>
    );
}

export default CustomizedTables;


